module.exports = __webpack_public_path__ + "static/media/milk.0812915e.jpg";